const sanitizeDomain = (value) => {
  if (!value || typeof value !== "string") return null;
  return value
    .trim()
    .replace(/^https?:\/\//i, "")
    .replace(/\/.*$/, "")
    .toLowerCase();
};

export const getVerificationSenderAddress = () => {
  const domain = sanitizeDomain(process.env.REACT_APP_FIREBASE_AUTH_DOMAIN);
  if (!domain) return null;
  return `noreply@${domain}`;
};

export const verificationInboxReminder =
  "CHECK YOUR JUNK/SPAM FOLDER.";

export const getVerificationEmailFailureMessage = (error) => {
  switch (error?.code) {
    case "auth/too-many-requests":
      return "Too many verification requests were made. Wait a few minutes, then try again.";
    case "auth/network-request-failed":
      return "We could not reach the verification service. Check your connection and try again.";
    case "auth/unauthorized-continue-uri":
    case "auth/invalid-continue-uri":
    case "auth/missing-continue-uri":
      return "The verification link could not be prepared. Please try again or contact support.";
    default:
      return "The verification email could not be sent. Please try again.";
  }
};
